import { io } from 'socket.io-client';
let socket = null;

const SOCKET_URL = process.env.REACT_APP_URL;

export const connectionWithSocketServer = token => {
  const jwtToken = token;
  socket = io(SOCKET_URL, {
    auth: {
      token: jwtToken,
      //   type: 'business',
    },
  });

  // socket.on('connect', () => {
  //   console.log('User Connected');
  // });

  socket.on('notification', data => {
    switch (data?.actionType) {
      case 'task_submitted':
      case 'task_running':
      case 'task_failed':
      case 'task_succeeded':
        window.dispatchEvent(new CustomEvent('task-notification', { detail: data }));
        break;

      case 'campaign_running':
      case 'campaign_draft':
      case 'campaign_completed':
      case 'campaign_insufficient_credits':
        window.dispatchEvent(new CustomEvent('campaign-notification', { detail: data }));
        break;

      case 'linkedin_task_submitted':
      case 'linkedin_task_running':
      case 'linkedin_task_failed':
      case 'linkedin_task_succeeded':
        window.dispatchEvent(new CustomEvent('linkedin-notification', { detail: data }));
        break;

      case 'subscription_updated':
      case 'subscription_canceled':
        window.dispatchEvent(new CustomEvent('subscription-notification', { detail: data }));
        break;

      case 'email_verifier_submitted':
      case 'email_verifier_running':
      case 'email_verifier_failed':
      case 'email_verifier_succeeded':
        window.dispatchEvent(new CustomEvent('email-verifier-notification', { detail: data }));
        break;

      case 'import_job_lead_chunk_completed':
        window.dispatchEvent(new CustomEvent('import-job-lead-notification', { detail: data }));
        break;

      // case 'import_job_queued':
      case 'import_job_completed':
      case 'import_job_failed':
        window.dispatchEvent(new CustomEvent('import-job-lead-notification', { detail: data }));
        break;

      case 'email_account_already_exists':
        window.dispatchEvent(new CustomEvent('email-account-already-exists', { detail: data }));
        break;

      default:
        window.dispatchEvent(new CustomEvent('notification', { detail: data }));
        break;
    }
  });

  // socket.on('disconnect', () => {
  //   console.log('User disconnect');
  // });
};

export const socketServer = () => socket;

export const disconnectSocket = () => {
  try {
    if (socket) {
      socket.removeAllListeners && socket.removeAllListeners();
      socket.off && socket.off();
      socket.disconnect && socket.disconnect();
    }
  } finally {
    socket = null;
  }
};
